"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SORT_BUTTON_CATEGORY_KEY = 'base';
exports.SORT_BUTTON_COMPONENT_KEY = 'sortButton';